<template>
    <div style="background-color:white;" v-if="!loading">
        <van-row style="padding:20px 20px 20px 20px;background-color: white;">
            <van-col span="12" style="text-align:left;">
                <img src="../../../assets/img/sany.png" style="height:41px;vertical-align:middle"/>
            </van-col>
            <van-col span="12" style="text-align:right;">
                <p style='font-size: 24px;margin:3px;color:red;'>审计监察总部</p>
            </van-col>
        </van-row>
        <div width='100%' style="height:2px;width:100%;background-color:red;"></div>
        <MyEditor :valueHtml="form.reportContent" :heights="true" class="article" style="padding-bottom:20px;" :selectDisabled="true"/>
    </div>
    <div v-else>
        文档加载中，请稍后...
    </div>
    
</template>
<script>
import MyEditor from "@/plugins/myEditor"
import * as bsOffice from "@/utils/bsOffice.js";
export default {
    components:{
        MyEditor
    },
    data(){
        return {
            loading:false,
            curUserNo:'',
            form:{},
            reportTypes:{
                '1':'风险通报',
                '2':'问责通报'
            }
        }
    },
    created(){
        // window.close()
        this.loading = true
        this.curUserNo = this.$userNo()
        document.title='通报'
        this.initData()
    },
    mounted(){
    },
    methods:{
        initData(){
            let guid = this.$route.query.guid
            this.$http.get('/api/job/v0.1/riskReport/getViewByGuid?guid='+guid)
            .then(async res=>{
                document.title = this.reportTypes[res.data.reportType]
                if(res.data.fileIds){
                    window.location.href = await bsOffice.readUrl(res.data.fileIds,res.data.reportName+'.docx')
                    return
                }
                this.form = res.data
                this.loading = false
            })
        },
        toBsOffice(fileGuid){

        },
        replace_html_tag_style(src_str,tag,attr,val){
            if(!src_str){
            return
            }
            var reg = new RegExp("<"+tag+"[ |>][^>]*>",'gi');
            return src_str.replace(reg,(match)=>{
            if(match.indexOf(attr)>-1){
                return match
            }
            if(match.indexOf(' style="')>0){
                return match.replace(' style="',' style="'+attr+":"+val+';')
            }else if(match.indexOf(' style=\'')>0){
                return match.replace(' style=\'',' style=\''+attr+":"+val+';')
            }else{
                return match.replace('<'+tag,'<'+tag+' style=\''+attr+":"+val+';\'')
            }
            })
        }
    }
}
</script>